import { motion } from 'framer-motion';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Skeleton from '../../../components/Skeleton';
import Shimmer from '../../../components/Shimmer';
import './style.scss';

const SKELETON_ARRAY = Array.from({ length: 2 }, () => ({ key: 'product-skeleton-' + Math.floor(Math.random() * 6)}));

function ProductListSkeleton(props: any) {

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="ProductListSkeleton"
      {...props}
    >
      {
        SKELETON_ARRAY.map((item, index) => (
          <div className="ProductItem" key={item.key}>
            <Container>
                <Row>
                  <Col className="ProductItem__col_image">
                    <Skeleton type="thumbnail"/>
                  </Col>
                  <Col className="ProductItem__col_form">
                    <Row className="ProductItem_btn_container">
                      <Skeleton type="title" />
                    </Row>
                    <Row>
                    <Skeleton type="text" />
                    </Row>
                  </Col>
                </Row>
            </Container>
          </div>
        ))}
      <Shimmer />
    </motion.section>
  );
}

export default ProductListSkeleton;
